import * as React from "react";
const ConfiguratorContext = React.createContext(null);
const useConfiguratorContext = () => {
  const context = React.useContext(ConfiguratorContext);
  if (context === null) {
    throw Error(
      `Consumer of useConfiguratorContext needs to be wrapped in a ConfiguratorContext provider.`
    );
  }
  return context;
};
const ConfiguratorContextProvider = ({
  children,
  /**
   * This is everything in ConfiguratorContextModel
   */
  ...rest
}) => /* @__PURE__ */ React.createElement(ConfiguratorContext.Provider, { value: rest }, children);
export {
  ConfiguratorContext,
  ConfiguratorContextProvider,
  useConfiguratorContext
};
//# sourceMappingURL=ConfiguratorContext.js.map
